var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCn = function SvgCn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 30 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DE2910",
    d: "M0 0h30v20H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFDE00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 2 4 11-8-7h8l-7 7zM14 4l1 3.5L12.5 6h3L13 7.5zM17 7l1 3.5L15.5 9h3L16 10.5zM17 11.5l1 3.5-2.5-1.5h3L16 15zM14 14.5l1 3.5-2.5-1.5h3L13 18z"
  }))));
};
export { SvgCn as ReactComponent };
export default __webpack_public_path__ + "fa6ab7b94ff18f9d66684179c1a395e6.svg";